import React, { useCallback } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Columns from './DataComponent__TableColumns';
import actions from './DataComponent.actions';

const DataComponentSettings = ({
    settings: propSettings,
    tableBodyTitle: propTableBodyTitle,
    settingKey: propSettingKey,
    data: propData
}) => {
    const renderSettings = useCallback(() => {
        if (!propSettings) return null;

        return (
            <React.Fragment>
                <div className={`settingsBar ${propTableBodyTitle ? 'settingsBar--withTitle' : ''}`}>
                    <div>
                        <Columns
                            settingKey={propSettingKey}
                            data={propData}
                            onApply={actions.saveServerStorage}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }, [propSettings, propTableBodyTitle, propSettingKey, propData]);

    return renderSettings();
};

DataComponentSettings.propTypes = {
    settings: PropTypes.bool,
    tableBodyTitle: PropTypes.string,
    settingKey: PropTypes.string,
    data: PropTypes.array
};

DataComponentSettings.defaultProps = {
    settings: false,
    tableBodyTitle: '',
    settingKey: '',
    data: []
};

export default withTranslation(DataComponentSettings);
